import { createFileRoute } from '@tanstack/react-router';
import { eventBannerSlot } from '@/app/commercial/slots';
import { EventEditor } from '@/modules/events/public';
import { RequirePermission } from '@/modules/identity/public';

export const Route = createFileRoute('/_admin/eventos/novo')({
  component: function NewEventRoute() {
    const navigate = Route.useNavigate();
    return (
      <RequirePermission anyOf={['eventos.editar']}>
        <EventEditor
          canEdit
          imageSlot={eventBannerSlot}
          onBack={() => navigate({ to: '/eventos' })}
          onSaved={(e) => navigate({ to: '/eventos/$eventId', params: { eventId: e.id }, replace: true })}
          onDeleted={() => navigate({ to: '/eventos' })}
        />
      </RequirePermission>
    );
  },
});
